{
  "version": 1,
  "asset_id": "1924b2b1-ab45-4471-bf56-902fd07f4505",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/1924b2b1-ab45-4471-bf56-902fd07f4505/ind-real-estate-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/1924b2b1-ab45-4471-bf56-902fd07f4505/ind-real-estate-640.avif",
  "original_filename": "ind-real-estate-640.avif",
  "size": 5293,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:10Z"
}
